<template>
  <span v-if="isMultipleAuthorsVisible" class="authors__wrapper">
    <a-author
      :key="article.publishers[0].name"
      v-bind="article.publishers[0]"
    />
    and
    <a-author
      :key="article.publishers[1].name"
      v-bind="article.publishers[1]"
    />
  </span>
  <a-author v-else-if="isSingleAuthorVisible" v-bind="article.publishers[0]" />
</template>

<script>
import AAuthor from 'shared/AAuthor'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
export default {
  name: 'AAuthors',
  components: { AAuthor },
  props: {
    article: propValidator([PROP_TYPES.OBJECT])
  },
  computed: {
    isMoreThanOneAuthor() {
      return this.article.publishers.length > 1
    },
    isMultipleAuthorsVisible() {
      return this.article.publishers.length && this.isMoreThanOneAuthor
    },
    isSingleAuthorVisible() {
      return !!this.article.publishers.length && !this.isMoreThanOneAuthor
    }
  }
}
</script>
